class @App.Pages.Patrons
  constructor: ->
    $('a[data-toggle="chart-help"]').on 'click', (e) ->
      $toggle = $(this)
      e.preventDefault()
      $chart_info_content = $('.chart-info-content')

      if $toggle.hasClass 'toggle-content-hidden'
        $toggle.addClass('toggle-content-shown').removeClass('toggle-content-hidden')
        $chart_info_content.slideDown 'fast'
      else
        $toggle.addClass('toggle-content-hidden').removeClass('toggle-content-shown')
        $chart_info_content.slideUp 'fast'

$(document).on 'turbo:load', ->
  new App.Pages.Patrons if $(document.body).hasClass 'patronsIndexView'
